<template>
  <div class="port">
    <div class="gate gate-left" :class="{ open: openGates }"></div>
    <div class="gate gate-right" :class="{ open: openGates }"></div>
    <div class="turn-key" :class="{ turned: open, gone: openGates }"></div>
  </div>
</template>

<script>
export default {
  name: 'Port',
  data () {
    return {
      openGates: false
    }
  },
  props: ['open'],
  watch: {
    open () {
      if (this.open) {
        window.setTimeout(() => {
          this.openGates = true
        }, 1000)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .port {
    margin-top: 3.6vh;
    width: 100%;
    height: 20.7vh;
    background-image: url('./../assets/images/gateholders.svg');
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
    position: relative;
  }
  .turn-key {
    background-color: #ffbf00;
    height: 6vh;
    width: 0.7vh;
    position: absolute;
    top: calc(50% + 1.5vh);
    left: 50%;
    margin-left: -0.60vh;
    border: solid 0.2vh #e5a505;
    border-radius: 0.3vh;
    transition: transform 1s linear;
    opacity: 0;
  }
  .turn-key.turned {
    opacity: 1;
    transform: rotate(90deg);
  }
  .turn-key.gone {
    display: none;
  }
  .gate {
    width: 9vh;
    height: 40vh;
    position: absolute;
    top: -8.4vh;
    background-image: url('./../assets/images/gate.svg');
    background-size: 200%;
    background-repeat: no-repeat;
  }
  .gate-left {
    right: 50%;
    transform: rotate3d(0, 1, 0, 0deg);
    background-position: 0vh 50%;
    transform-origin: 0% 50%;
  }
  .gate-right {
    left: 50%;
    background-position: -9vh 50%;
    transform-origin: 100% 50%;
    transform: rotate3d(0, 1, 0, 0deg);
  }
  .gate.open {
    transition: all 3s ease-out;
    transform: rotate3d(0, 1, 0, -65deg);
  }
  @keyframes mywheel1 {
    from {
      transform: rotate3d(0, 1, 0, -65deg);
    }
    to {
      transform: rotate(-360deg);
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Port.vue